// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@werner/XDL/types";

export default {
    primary: {
        main: "#0064B0",
        contrast: "#FFFFFF",
    },
    secondary: {
        main: "#FFCE34",
        contrast: "#FFFFFF",
    },
    common: {
        background: "#FFFFFF",
        backgroundContrast: "#363636",
        accent: "#F8F9FA",
        accentContrast: "#363636",
        border: "#9AA0A0",
        disabled: "#CCCCCC",
        ui1: "#9AA0A0",
        ui2: "#EDEDED",
        ui3: "#6D6E71",
        ui4: "#A3AAAA",
        ui5: "#DCDEDE",
        ui6: "#4a4a4a",
        ui7: "#f3f5f9",
        ui8: "#F9F9F9",
        ui9: "#999999",
        white: "#FFFFFF",
        black: "#000000",
    },
    text: {
        main: "#2C2C2C",
        disabled: "#475353",
        accent: "#2D3435",
        link: "#0064B0",
        brand2: "#333333",
    },
    success: {
        main: "#3AA248",
        contrast: "#FFFFFF",
    },
    danger: {
        main: "#D62D2C",
        contrast: "#FFFFFF",
    },
    warning: {
        main: "#E4963E",
        contrast: "#FFFFFF",
    },
    info: {
        main: "#369CD6",
        contrast: "#FFFFFF",
    },
} as xBaseTheme["colors"];
